import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import { OrganizationResearcher } from 'src/types/organizations';
import { useTranslation } from 'react-i18next';
import { TooltipButton } from '..';
import { CohortsIcon2 } from '@medeloop/medeloop-components-library';
import { createSearchParams, useNavigate } from 'react-router-dom';

interface OrganizationResearchersTableProps {
  researchers: OrganizationResearcher[];
  allowActions?: boolean;
}

export function OrganizationResearchersTable({
  researchers,
  allowActions,
}: OrganizationResearchersTableProps) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleResearcherAssign = (userId: string) => {
    navigate({
      pathname: 'assign-researcher',
      search: `?${createSearchParams({ userId })}`,
    });
  };

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell flexGrow={1}>{t('first_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell flexGrow={1}>{t('last_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell flexGrow={2}>{t('email_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell flexGrow={1}>{t('role_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell flexGrow={1} />
      </DataTable.Header>

      <DataTable.Body className="h-96 overflow-auto">
        {researchers.length > 0 ? (
          researchers.map((researcher: OrganizationResearcher) => (
            <DataTable.Row key={researcher.researcherId}>
              <DataTable.RowCell flexGrow={1} align="center">
                {researcher.researcherGivenName}
              </DataTable.RowCell>
              <DataTable.RowCell flexGrow={1} align="center">
                {researcher.researcherFamilyName}
              </DataTable.RowCell>
              <DataTable.RowCell flexGrow={2} align="center">
                {researcher.researcherEmail}
              </DataTable.RowCell>
              <DataTable.RowCell flexGrow={1} align="center">
                {researcher.isAdmin ? t('admin') : t('researcher')}
              </DataTable.RowCell>
              <DataTable.RowCell flexGrow={1} align="center">
                {allowActions && !researcher.isAdmin && (
                  <TooltipButton
                    tooltipText={t('assign_to_study_or_data_source')}
                    onClick={() => handleResearcherAssign(researcher.userId)}
                  >
                    <CohortsIcon2 className="text-gray-500" />
                  </TooltipButton>
                )}
              </DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow text-white items-center justify-center p-4">
            {t('no_researchers_created')}
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
